import { useQueryParameter } from '@hotjar/webapp/hooks/useQueryParameter';

interface JoinTeamQueryParameters {
  tokenQueryParam: string | undefined;
  nextParam: string | undefined;
  errorCodeQueryParam: string | undefined;
  utmSourceQueryParam: string | undefined;
  utmMediumQueryParam: string | undefined;
  utmCampaignQueryParam: string | undefined;
}

export const useJoinTeamQueryParameters = (): JoinTeamQueryParameters => {
  const tokenQueryParam = useQueryParameter('token');
  const nextParam = useQueryParameter('next');
  const errorCodeQueryParam = useQueryParameter('error_code');
  const utmSourceQueryParam = useQueryParameter('utm_source');
  const utmMediumQueryParam = useQueryParameter('utm_medium');
  const utmCampaignQueryParam = useQueryParameter('utm_campaign');

  return {
    tokenQueryParam,
    nextParam,
    errorCodeQueryParam,
    utmSourceQueryParam,
    utmMediumQueryParam,
    utmCampaignQueryParam,
  };
};
